var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 128 128",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", {
    className: "active-path",
    style: {}
  }, "RING"), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.086,33.487,87.57,15.53A1.81,1.81,0,0,0,87.7,13.2L77.7.659A1.807,1.807,0,0,0,76.333,0H51.667A1.807,1.807,0,0,0,50.3.659L40.3,13.2a1.81,1.81,0,0,0,.131,2.329L57.914,33.487a47.458,47.458,0,1,0,12.173,0ZM51.8,4.385l8.021,8.157H45.3Zm30.9,8.157H68.175L76.2,4.385Zm-14.034,3.5L64,29.493,59.334,16.042Zm3.7,0h9.817L66.938,31.7ZM64,11.8,55.842,3.5H72.158Zm-8.37,4.246L61.062,31.7,45.813,16.042ZM64,124.5a43.958,43.958,0,1,1,43.958-43.958A44.008,44.008,0,0,1,64,124.5Z",
    "data-original": "#000000",
    className: "active-path",
    fill: "#6A6464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64,40.822a39.719,39.719,0,1,0,39.72,39.72A39.765,39.765,0,0,0,64,40.822Zm0,75.938a36.219,36.219,0,1,1,36.22-36.219A36.26,36.26,0,0,1,64,116.761Z",
    "data-original": "#000000",
    className: "active-path",
    fill: "#6A6464"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.5762fa5cb25991e3561749d96981ac1b.svg";
export { ForwardRef as ReactComponent };